import { IUserInfoItem } from "@valenzinsights/react-core";

import { userConfiguration } from "./profile-configrations";

export * from "./theme";

export * from "./header-menu-items";

export * from "./profile-configrations";

interface IItemData {
	userConfiguration: IUserInfoItem;
}

export const itemData: IItemData = {
	userConfiguration: userConfiguration,
};
